import Container from '@zenbusiness/zui/Container';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const FixedContainer = superstyled({
  name: 'CtaContainer',
  slot: 'Fixed',
  tag: Container,
  propsAdded: {
    'data-testid': 'cta-fixed-container'
  },
  styles: ({ theme }) => ({
    background: theme.palette.background.grey.alpha.light,
    backdropFilter: 'blur(12px)',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1
  })
});

export const Actions = superstyled({
  name: 'CtaContainer',
  slot: 'Actions',
  tag: Stack,
  propsNeeded: ['marginBlockStart'],
  propsAdded: {
    'data-testid': 'cta-container'
  },
  styles: ({ theme, marginBlockStart }) => ({
    gap: theme.spacing(1),
    paddingBlock: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      marginBlockStart: theme.spacing(marginBlockStart ?? 3),
      paddingBlock: 0
    }
  })
});
